module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABMklEQVQ4T5XUTU7DMBAF4DdOW+UAcAv+JCRO0KzgQmlE5V1yIBZILWxAICQoHATEpqskttFEpIpdx0mzjOJPM28mpkW2fAUgZlNxLaX8xgFPmqbHJKJ7QGxpkS3fAHMFmK/ZdJKMxf6RR4BOAHomKeVRWdUrgC7GYl2EgA+lqoS4ExczWs3zPP/xdelDiqL4baCxGCMQkwcCTttKGOHzO2gICyF7kIsR8Kl1nfBUSURrgM7cStqOrIp8bTJmYKIQ4q3In1mTQTOdNhN3EN6K+CN7T/hNeM+8kI2YDYEiA5wz1rcae5CLaFXP4ziOqkqtQ5gFdUcMmA0jbSa8tCFsB4WQ7gD6sAYagwxhdAgSwijLbt8NcOlmMnQt2ZnRC99HT/wLaFXe9C1bH9rcGqW6A2H7Bx01N+lt8HLiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/X.png
// module id = N6lU
// module chunks = 0